export default "__VITE_PUBLIC_ASSET__6eeb5942__"